<p-tabs value="0" [(value)]="activeTab">
    <p-tablist>
        <p-tab value="0" class="text-xs py-2 px-4">Comercial</p-tab>
        <p-tab value="1" class="text-xs py-2 px-4">Operaciones</p-tab>
        <p-tab value="2" class="text-xs py-2 px-4">Finanzas</p-tab>
        <p-tab value="3" class="text-xs py-2 px-4">Sistemas</p-tab>
        <p-tab value="4" class="text-xs py-2 px-4">PPS</p-tab>
    </p-tablist>
    <p-tabpanels>
        <p-tabpanel value="0">
            <p-tabs [(value)]="subTab">
                <p-tablist>
                    <p-tab value="0" class="text-xs py-2 px-4">Comparativo de Clientes por Año - ETA</p-tab>
                    <p-tab value="1" class="text-xs py-2 px-4">Pareto Vendedor</p-tab>
                    <!-- <p-tab value="2" class="text-xs py-2 px-4">Rentabilidad Bruta vs Costo Por Ejecutivo</p-tab>
                    <p-tab value="3" class="text-xs py-2 px-4">Reporte Flujo Proyectado - ETA</p-tab>
                    <p-tab value="4" class="text-xs py-2 px-4">Comportamiento Historico - ETA</p-tab>
                    <p-tab value="5" class="text-xs py-2 px-4">Resumen Productividad Mensual</p-tab>
                    <p-tab value="6" class="text-xs py-2 px-4">Proyección Forecast - Producción</p-tab> -->
                </p-tablist>
                <p-tabpanels>
                    <p-tabpanel value="0">
                        <ng-container *ngIf="subTab === 0">
                            <app-reporte-comparativo-cliente-eta></app-reporte-comparativo-cliente-eta>
                        </ng-container>
                    </p-tabpanel>
                    <p-tabpanel value="1">
                        <app-reporte-pareto-vendedor></app-reporte-pareto-vendedor>
                    </p-tabpanel>
                </p-tabpanels>
            </p-tabs>
        </p-tabpanel>
        <p-tabpanel value="1">
        </p-tabpanel>
        <p-tabpanel value="2">
        </p-tabpanel>
        <p-tabpanel value="3">
        </p-tabpanel>
        <p-tabpanel value="4">
        </p-tabpanel>
    </p-tabpanels>
</p-tabs>

<button (click)="requestNotificationPermission()">Habilitar Notificaciones</button>
<button (click)="showNotification()">Mostrar Notificación</button>

<!-- <p-tabView>
    <p-tabPanel header="Comercial" *ngIf="permisoActivo('Comercial')">
        <div class="a-example-full-width-alterno-content">
            <p-tabView #TabComercial [(activeIndex)]="activeIndex" (onChange)="onChangeTab($event,'comercial')">
                <p-tabPanel header="Comparativo de Clientes por Año - ETA" [selected]="activeIndex === 0">
                    <app-bandeja-comparativo-cliente-anio
                        *ngIf="hasLoadedComercial['Comparativo de Clientes por Año - ETA']"></app-bandeja-comparativo-cliente-anio>
                </p-tabPanel>
                <p-tabPanel header="Pareto Vendedor" [selected]="activeIndex === 1">
                    <app-bandeja-pareto-vendedor-eta
                        *ngIf="hasLoadedComercial['Pareto Vendedor']"></app-bandeja-pareto-vendedor-eta>
                </p-tabPanel>
                <p-tabPanel header="Rentabilidad Bruta vs Costo Por ejecutivo" [selected]="activeIndex === 2">
                    <app-bandeja-rentabilidad-costo-ejecutivo
                        *ngIf="hasLoadedComercial['Rentabilidad Bruta vs Costo Por ejecutivo']"></app-bandeja-rentabilidad-costo-ejecutivo>
                </p-tabPanel>
                <p-tabPanel header="Reporte Flujo Proyectado - ETA" [selected]="activeIndex === 3">
                    <app-bandeja-flujo-proyectado-simulador
                        *ngIf="hasLoadedComercial['Reporte Flujo Proyectado - ETA']"></app-bandeja-flujo-proyectado-simulador>
                </p-tabPanel>
                <p-tabPanel header="Comportamiento Historico - ETA" [selected]="activeIndex === 4">
                    <app-reporte-rentabilidad-lnegocio
                        *ngIf="hasLoadedComercial['Comportamiento Historico - ETA']"></app-reporte-rentabilidad-lnegocio>
                </p-tabPanel>
                <p-tabPanel header="Resumen Productividad Mensual" [selected]="activeIndex === 5">
                    <app-resumen-mensual-comercial
                        *ngIf="hasLoadedComercial['Resumen Productividad Mensual']"></app-resumen-mensual-comercial>
                </p-tabPanel>
                <p-tabPanel header="Proyección Forecast - Producción" [selected]="activeIndex === 6">
                    <app-bandeja-proyeccion-forecast-produccion
                        *ngIf="hasLoadedComercial['Proyección Forecast - Producción']"></app-bandeja-proyeccion-forecast-produccion>
                </p-tabPanel>
            </p-tabView>
        </div>
    </p-tabPanel>
    <p-tabPanel header="Operaciones" *ngIf="permisoActivo('Operaciones')">
        <p-tabView #TabOperaciones [(activeIndex)]="activeIndex" (onChange)="onChangeTab($event,'operaciones')">
            <p-tabPanel header="Reporte Servicio Contenedores">
                <app-bandeja-ctnr-almacen
                    *ngIf="hasLoadedOperaciones['Reporte Servicio Contenedores']"></app-bandeja-ctnr-almacen>
            </p-tabPanel>
            <p-tabPanel header="Transmisión">
                <app-indicadores-transmision *ngIf="hasLoadedOperaciones['Transmisión']"></app-indicadores-transmision>
            </p-tabPanel>
            <p-tabPanel header="Statement">
                <app-indicadores-statement *ngIf="hasLoadedOperaciones['Statement']"></app-indicadores-statement>
            </p-tabPanel>
            <p-tabPanel header="Aviso LLegada">
                <app-indicadores-aviso-llegada
                    *ngIf="hasLoadedOperaciones['Aviso LLegada']"></app-indicadores-aviso-llegada>
            </p-tabPanel>
            <p-tabPanel header="Desglose">
                <app-indicador-desglose *ngIf="hasLoadedOperaciones['Desglose']"></app-indicador-desglose>
            </p-tabPanel>
            <p-tabPanel header="Comportamiento OV">
                <app-indicadores-comportamiento-ov
                    *ngIf="hasLoadedOperaciones['Comportamiento OV']"></app-indicadores-comportamiento-ov>
            </p-tabPanel>
        </p-tabView>
    </p-tabPanel>
    <p-tabPanel header="Finanzas" *ngIf="permisoActivo('Finanzas')">
        <p-tabView #TabFinanzas [(activeIndex)]="activeIndex" (onChange)="onChangeTab($event,'finanzas')">
            <p-tabPanel header="Dashboard Finanzas">
                <app-reporte-niveles-credito
                    *ngIf="hasLoadedFinanzas['Dashboard Finanzas']"></app-reporte-niveles-credito>
            </p-tabPanel>
        </p-tabView>
    </p-tabPanel>
    <p-tabPanel header="Sistemas" *ngIf="permisoActivo('Sistemas')">
        <p-tabView #TabSistemas [(activeIndex)]="activeIndex" (onChange)="onChangeTab($event,'sistemas')">
            <p-tabPanel header="Dashboard Soporte">
                <app-dashboard-soporte-bandeja
                    *ngIf="hasLoadedSistemas['Dashboard Soporte']"></app-dashboard-soporte-bandeja>
            </p-tabPanel>
        </p-tabView>
    </p-tabPanel>
    <p-tabPanel header="PPS">
        <app-reporte-pps></app-reporte-pps>
    </p-tabPanel>
</p-tabView>
<div class="a-footer"></div> -->